import { Actor, HttpAgent } from '@dfinity/agent';
import { ORIGYN_NFT_DID } from '../candid/origyn-nft/did';
/**
 * Dfinity actors manager
 */
export class ActorManager {
    constructor() {
        this.actors = [];
        this.initialized = false;
    }
    /**
     * Creates actors based on configuration with the specified identity
     * @param {ActorConfig[]} config
     * @param {SignIdentity | undefined} identity
     */
    async init(config, identity) {
        if (this.initialized) {
            return;
        }
        for (const actorConfig of config) {
            await this.initActor(actorConfig, identity);
            this.identity = identity;
            this.initialized = true;
        }
    }
    /**
     * Creates actor based on configuration with the specified identity
     * @param {ActorConfig} actorConfig
     * @param {SignIdentity} identity
     * @private
     */
    async initActor(actorConfig, identity) {
        try {
            const { host, idl, name, canisterId, anonymous } = actorConfig;
            let agentIdentity;
            if (!anonymous) {
                agentIdentity = identity;
            }
            const agent = new HttpAgent({
                identity: agentIdentity,
                host,
            });
            const actor = Actor.createActor(idl, {
                agent,
                canisterId,
            });
            this.actors.push({
                name,
                actor,
                host,
            });
        }
        catch (e) { }
    }
    /**
     * Creates an actor for NFT Token canister
     * @param {string} canisterId
     * @return {Promise<ActorSubclass<OrigynNFTService>>}
     */
    async getOrigynNFTCanisterActor(canisterId) {
        const agent = new HttpAgent({
            host: `https://${canisterId}.raw.ic0.app`,
            identity: this.identity,
        });
        return Actor.createActor(ORIGYN_NFT_DID, {
            agent,
            canisterId,
        });
    }
    /**
     * Gets actor by name
     * @param {string} name
     * @return {ActorSubclass<T>}
     */
    getActor(name) {
        var _a;
        const actor = (_a = this.actors.find((actor) => actor.name === name)) === null || _a === void 0 ? void 0 : _a.actor;
        if (!actor) {
            throw new Error('Actor not found!');
        }
        return actor;
    }
    getActorHost(name) {
        var _a;
        return (_a = this.actors.find((actor) => actor.name === name)) === null || _a === void 0 ? void 0 : _a.host;
    }
    sign(blob) {
        if (!this.identity) {
            throw new Error('Identity not initialized!');
        }
        return this.identity.sign(blob);
    }
    getPublicKey() {
        if (!this.identity) {
            throw new Error('Identity not initialized!');
        }
        return this.identity.getPublicKey();
    }
}
export const ActorsPool = new ActorManager();
//# sourceMappingURL=ActorManager.js.map